import React, { useEffect, useState } from 'react';
import { BoxStyled } from '../../patientInformation/style';
import { TextWithInfoIcon } from '../../../shared/components/textWithInfoIcon';
import InfoIcon from '../../../assets/icons/infoIcon.svg';
import PowerIcon from '../../../assets/icons/powerIcon.svg';
import WalkingIcon from '../../../assets/icons/walkingIcon.svg';
import ChairIcon from '../../../assets/icons/chairIcon.svg';
import FallIcon from '../../../assets/icons/fallIcon.svg';
import WalkingStairsIcon from '../../../assets/icons/walkingStairsIcon.svg';
import { InfoModal } from '../../../shared/components/modal/InfoModal';
import { ArcContainer } from '../../../shared/components/arcContainer';
import { metaDataSelector } from '../../../store/globalSelectors';
import { useAppSelector } from '../../../store/hooks';

import { MCQComponent } from './mcqComponent';
import { sarcfConstants } from '../../../shared/shared.constants';
import { useDispatch } from 'react-redux';
import { setSarcfValues } from '../../../store/slices/metaDataSlice';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { Box, Modal } from '@mui/material';
import { AddOnInfoModal } from '../../../shared/components/modal/addOnInfoModal';

export const Sarcf = () => {
  const dispatch = useDispatch();
  const [openInfoModal, setOpenInfoModal] = useState(false);

  const { muscleScreening } = useAppSelector(metaDataSelector);
  const { sarcf } = muscleScreening;
  const { power, walking, chair, stairs, fall } = sarcf;

  const isNextDisabled = !(
    power !== '' &&
    walking !== '' &&
    chair !== '' &&
    stairs !== '' &&
    fall !== ''
  );

  const handleChange = (type, event) => {
    dispatch(
      setSarcfValues({
        ...sarcf,
        [type]: event?.target?.value
      })
    );
  };

  useEffect(() => {
    let totalScore = 0;
    const valueMapper = {
      notAtAll: 0,
      aLittle: 1,
      veryUnable: 2,
      oneToThreeTimes: 1,
      fourOrMoreFalls: 2
    };

    const powerScore = power !== '' ? valueMapper[power] : 0;
    const walkingScore = walking !== '' ? valueMapper[walking] : 0;
    const chairScore = chair !== '' ? valueMapper[chair] : 0;
    const stairsScore = stairs !== '' ? valueMapper[stairs] : 0;
    const fallScore = fall !== '' ? valueMapper[fall] : 0;

    totalScore =
      powerScore + walkingScore + chairScore + stairsScore + fallScore;

    dispatch(
      setSarcfValues({
        ...sarcf,
        totalScore: totalScore
      })
    );
  }, [power, walking, chair, stairs, fall]);

  const handleSectionOneChange = (
    _type: string,
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleChange(sarcfConstants.sectionOne.id, val);
  };

  // REF: For Section Two
  const handleSectionTwoChange = (
    _type: string,
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleChange(sarcfConstants.sectionTwo.id, val);
  };

  const handleSectionThreeChange = (
    _type: string,
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleChange(sarcfConstants.sectionThree.id, val);
  };

  const handleSectionFourChange = (
    _type: string,
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleChange(sarcfConstants.sectionFour.id, val);
  };

  const handleSectionFiveChange = (
    _type: string,
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleChange(sarcfConstants.sectionFive.id, val);
  };

  return (
    <>
      <BoxStyled>
        {/* Top Bar (title + info icon) */}
        <TextWithInfoIcon
          title={'Sarc-f'}
          icon={InfoIcon}
          fontSize={'1.625rem'}
          lineHeight={'1.375rem'}
          variant={'h1'}
          handleIconClick={() => setOpenInfoModal(true)}
          testId="sarcfInfoPopup"
        />
      </BoxStyled>
      <ArcContainer icon={PowerIcon} customizedHeight="auto">
        <BoxStyled sx={{ marginTop: '1.25rem' }} className="pt-16">
          <MCQComponent
            id={sarcfConstants?.sectionOne?.id}
            title={sarcfConstants?.sectionOne?.title}
            question={sarcfConstants?.sectionOne?.question}
            options={sarcfConstants?.sectionOne?.options}
            handleChange={handleSectionOneChange}
            value={power}
          />
        </BoxStyled>
      </ArcContainer>

      <ArcContainer icon={WalkingIcon} customizedHeight="auto">
        <BoxStyled sx={{ marginTop: '1.25rem' }} className="pt-16">
          <MCQComponent
            id={sarcfConstants?.sectionTwo?.id}
            title={sarcfConstants?.sectionTwo?.title}
            question={sarcfConstants?.sectionTwo?.question}
            options={sarcfConstants?.sectionTwo?.options}
            handleChange={handleSectionTwoChange}
            value={walking}
          />
        </BoxStyled>
      </ArcContainer>

      <ArcContainer icon={ChairIcon} customizedHeight="auto">
        <BoxStyled sx={{ marginTop: '1.25rem' }} className="pt-16">
          <MCQComponent
            id={sarcfConstants?.sectionThree?.id}
            title={sarcfConstants?.sectionThree?.title}
            question={sarcfConstants?.sectionThree?.question}
            options={sarcfConstants?.sectionThree?.options}
            handleChange={handleSectionThreeChange}
            value={chair}
          />
        </BoxStyled>
      </ArcContainer>

      <ArcContainer icon={WalkingStairsIcon} customizedHeight="auto">
        <BoxStyled sx={{ marginTop: '1.25rem' }} className="pt-16">
          <MCQComponent
            id={sarcfConstants?.sectionFour?.id}
            title={sarcfConstants?.sectionFour?.title}
            question={sarcfConstants?.sectionFour?.question}
            options={sarcfConstants?.sectionFour?.options}
            handleChange={handleSectionFourChange}
            value={stairs}
          />
        </BoxStyled>
      </ArcContainer>

      <ArcContainer icon={FallIcon} customizedHeight="auto">
        <BoxStyled sx={{ marginTop: '1.25rem' }} className="pt-16">
          <MCQComponent
            id={sarcfConstants?.sectionFive?.id}
            title={sarcfConstants?.sectionFive?.title}
            question={sarcfConstants?.sectionFive?.question}
            options={sarcfConstants?.sectionFive?.options}
            handleChange={handleSectionFiveChange}
            value={fall}
          />
        </BoxStyled>
      </ArcContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
        <NavigationButtons
          nextRoute={'/muscle-screening/sarc-f/screening-result'}
          nextDisabled={isNextDisabled}
        />
      </Box>
      {/* <InfoModal
        open={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        title={'Reference: '}
        content={
          'Malmstrom et al. J Cachexia Sarcopenia Muscle. 2015 Jul 7;7(1):28–36. <br><br>  <span style="color: #002A3A"><b>SARC-F</b> = Strength, assistance walking, rise from a chair, climb stairs, and falls</span>'
        }
      /> */}
      <Modal
        open={openInfoModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`SARC-F`}
          description1={` = Strength, assistance walking, rise from a chair, climb stairs, and falls`}
          title={`Reference:`}
          content={`Malmstrom T.K. Morley M. JAMDA. 2013; 14(8):531-532`}
          onClose={() => setOpenInfoModal(false)}
        />
      </Modal>
    </>
  );
};
